
export namespace GAType {
    // Runtime marker - makes this namespace exist at runtime (required for emitDecoratorMetadata)
    export const _brand = Symbol('GAType');

    export type EventType = 'send';
    export type HitType = 'event' | 'pageview';
    export type EventCategory = 'anchor' | 'button' | 'select-dialog' | 'message' | 'network' | 'auto';
    export type EventAction = 'page-change' | 'file-upload-start' | 'file-upload-end' | 'file-upload-failed' | 'file-upload-ready' | 'file-upload-clicked' | 'file-selected' |
        'file-convert-start' | 'file-convert-end' | 'file-convert-failed' |
        'offline-engine-downloaded' |
        'file-download' | 'model-open' | 'file-download-zip' |
        'file-select-dialog-opened' |
        'file-processor-resolve-start' |
        'file-processor-resolve-end' |
        'file-processor-resolve-failed';
    export type EventLabel = 'navigate' | 'download' | 'upload' | 'select' | 'convert' | 'error' |
        'complete' | 'package_download';
    export type EventValue = any;
}
